module.exports = __webpack_public_path__ + "img/hand.8db21966.png";